/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} My_Grower_Report_By_YearInputs */

const vi_my_grower_report_by_year = /** @type {(inputs: My_Grower_Report_By_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Từng năm`)
};

/**

* @param {My_Grower_Report_By_YearInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const my_grower_report_by_year = /** @type {((inputs?: My_Grower_Report_By_YearInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Grower_Report_By_YearInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_my_grower_report_by_year(inputs)
});